import _styled from "@emotion/styled/base";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles, rem, breakpoints } from './../../styles';
export var prepareResponsiveProps = function prepareResponsiveProps(defaultValue, inputValue) {
  return Object.keys(breakpoints).reduce(function (acc, cur) {
    if (inputValue === null || inputValue === undefined) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, defaultValue));
    }
    if (_typeof(inputValue) !== 'object') {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, inputValue));
    }
    if (cur === 'xl') {
      inputValue[cur] = inputValue.xl || inputValue.lg;
    }
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, inputValue[cur] || defaultValue));
  }, {});
};
var generateMediaQueries = function generateMediaQueries() {
  return Object.keys(breakpoints).reduce(function (acc, cur) {
    var _breakpoints$cur = _slicedToArray(breakpoints[cur], 2),
      minWidth = _breakpoints$cur[0],
      maxWidth = _breakpoints$cur[1];
    var mediaQuery = ['@media only screen', minWidth ? "(min-width: ".concat(rem(minWidth), ")") : undefined, maxWidth ? "(max-width: ".concat(rem(maxWidth - 1), ")") : undefined].filter(function (item) {
      return item !== undefined;
    }).join(' and ');
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, mediaQuery));
  }, {});
};
export var mediaQueries = generateMediaQueries();
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "1s3v7gx-defaultStyles",
  styles: "display:flex;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles() {
  return _ref2;
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1lv1yo7",
  styles: "display:inline-flex"
} : {
  name: "1x7jzn1-isInlineModifier",
  styles: "display:inline-flex;label:isInlineModifier;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isInlineModifier = function isInlineModifier(_ref3) {
  var isBlock = _ref3.isBlock;
  if (!isBlock) {
    return _ref;
  }
};
var flexModifier = function flexModifier(_ref4) {
  var _ref4$flex = _ref4.flex,
    flex = _ref4$flex === void 0 ? 'auto' : _ref4$flex;
  var prop = typeof flex == 'string' ? flex : flex[1];
  var defaultProp = typeof flex == 'string' ? 'auto' : flex[0];
  var flexAlignment = prepareResponsiveProps(defaultProp, prop);
  var styles = "";
  for (var _i = 0, _Object$entries = Object.entries(mediaQueries); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    switch (flexAlignment[key]) {
      case 'none':
        styles += "\n          ".concat(value, " {\n            flex: none;\n          }\n        ");
        break;
      case 'auto':
        styles += "\n          ".concat(value, " {\n            flex: auto;\n          }\n        ");
        break;
    }
  }
  return /*#__PURE__*/css(styles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:flexModifier;"));
};
var alignItemsModifier = function alignItemsModifier(_ref5) {
  var _ref5$alignItems = _ref5.alignItems,
    alignItems = _ref5$alignItems === void 0 ? 'top' : _ref5$alignItems;
  var prop = typeof alignItems == 'string' ? alignItems : alignItems[1];
  var defaultProp = typeof alignItems == 'string' ? 'top' : alignItems[0];
  var flexAlignment = prepareResponsiveProps(defaultProp, prop);
  var styles = "";
  for (var _i2 = 0, _Object$entries2 = Object.entries(mediaQueries); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    switch (flexAlignment[key]) {
      case 'top':
        styles += "\n          ".concat(value, " {\n            align-items: flex-start;\n          }\n        ");
        break;
      case 'bottom':
        styles += "\n          ".concat(value, " {\n            align-items: flex-end;\n          }\n        ");
        break;
      case 'middle':
        styles += "\n          ".concat(value, " {\n            align-items: center;\n          }\n        ");
        break;
      case 'stretch':
        styles += "\n          ".concat(value, " {\n            align-items: stretch;\n          }\n        ");
        break;
      case 'baseline':
        styles += "\n          ".concat(value, " {\n            align-items: baseline;\n          }\n        ");
        break;
    }
  }
  return /*#__PURE__*/css(styles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:alignItemsModifier;"));
};
var justifyContentModifier = function justifyContentModifier(_ref6) {
  var _ref6$justifyContent = _ref6.justifyContent,
    justifyContent = _ref6$justifyContent === void 0 ? 'start' : _ref6$justifyContent;
  var prop = typeof justifyContent == 'string' ? justifyContent : justifyContent[1];
  var defaultProp = typeof justifyContent == 'string' ? 'start' : justifyContent[0];
  var flexAlignment = prepareResponsiveProps(defaultProp, prop);
  var styles = "";
  for (var _i3 = 0, _Object$entries3 = Object.entries(mediaQueries); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
      key = _Object$entries3$_i[0],
      value = _Object$entries3$_i[1];
    switch (flexAlignment[key]) {
      case 'center':
        styles += "\n          ".concat(value, " {\n            justify-content: center;\n          }\n        ");
        break;
      case 'start':
        styles += "\n          ".concat(value, " {\n            justify-content: flex-start;\n          }\n        ");
        break;
      case 'end':
        styles += "\n          ".concat(value, " {\n            justify-content: flex-end;\n          }\n        ");
        break;
      case 'around':
        styles += "\n          ".concat(value, " {\n            justify-content: space-around;\n          }\n        ");
        break;
      case 'between':
        styles += "\n          ".concat(value, " {\n            justify-content: space-between;\n          }\n        ");
        break;
      case 'stretch':
        styles += "\n          ".concat(value, " {\n            justify-content: stretch;\n          }\n        ");
        break;
    }
  }
  return /*#__PURE__*/css(styles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:justifyContentModifier;"));
};
var directionModifier = function directionModifier(_ref7) {
  var _ref7$direction = _ref7.direction,
    direction = _ref7$direction === void 0 ? 'row' : _ref7$direction;
  var prop = typeof direction == 'string' ? direction : direction[1];
  var defaultProp = typeof direction == 'string' ? 'row' : direction[0];
  var flexAlignment = prepareResponsiveProps(defaultProp, prop);
  var styles = "";
  for (var _i4 = 0, _Object$entries4 = Object.entries(mediaQueries); _i4 < _Object$entries4.length; _i4++) {
    var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
      key = _Object$entries4$_i[0],
      value = _Object$entries4$_i[1];
    switch (flexAlignment[key]) {
      case 'row':
        styles += "\n          ".concat(value, " {\n            flex-direction: row;\n          }\n        ");
        break;
      case 'row-reverse':
        styles += "\n          ".concat(value, " {\n            flex-direction: row-reverse;\n          }\n        ");
        break;
      case 'column':
        styles += "\n          ".concat(value, " {\n            flex-direction: column;\n          }\n        ");
        break;
      case 'column-reverse':
        styles += "\n          ".concat(value, " {\n            flex-direction: column-reverse;\n          }\n        ");
        break;
    }
  }
  return /*#__PURE__*/css(styles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:directionModifier;"));
};
var wrapModifier = function wrapModifier(_ref8) {
  var _ref8$wrap = _ref8.wrap,
    wrap = _ref8$wrap === void 0 ? 'nowrap' : _ref8$wrap;
  var prop = typeof wrap == 'string' ? wrap : wrap[1];
  var defaultProp = typeof wrap == 'string' ? 'nowrap' : wrap[0];
  var flexAlignment = prepareResponsiveProps(defaultProp, prop);
  var styles = "";
  for (var _i5 = 0, _Object$entries5 = Object.entries(mediaQueries); _i5 < _Object$entries5.length; _i5++) {
    var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
      key = _Object$entries5$_i[0],
      value = _Object$entries5$_i[1];
    switch (flexAlignment[key]) {
      case 'nowrap':
        styles += "\n          ".concat(value, " {\n            flex-wrap: nowrap;\n          }\n        ");
        break;
      case 'wrap':
        styles += " \n          ".concat(value, " { \n            flex-wrap: wrap;\n          }\n        ");
        break;
      case 'wrap-reverse':
        styles += "\n          ".concat(value, " {\n            flex-wrap: wrap-reverse;\n          }\n        ");
        break;
    }
  }
  return /*#__PURE__*/css(styles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:wrapModifier;"));
};
var resetStyles = getResetByTag('div');
var StyledFlex = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1f7c53y0"
} : {
  target: "e1f7c53y0",
  label: "StyledFlex"
})(resetStyles, defaultStyles, isInlineModifier, flexModifier, alignItemsModifier, justifyContentModifier, directionModifier, wrapModifier, utilityStyles);
export default StyledFlex;